// ข้อสอบของฉัน — รายการข้อสอบของครูผู้สอนในปีการศึกษาที่เลือก
import React, { useCallback, useEffect, useState } from 'react'
import { Badge, Button, Card, Col, Form, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import axiosInstance from '../services/axiosInterceptor'
import { useLoading } from '../contexts/LoadingContext'
import { API, fmt, readYearId, roomLabel, showError } from './examUtils'

export default function ExamList() {
  const { setLoading } = useLoading()
  const [, setSkin] = useState('')
  const [years, setYears] = useState([])
  const [yearId, setYearId] = useState(readYearId)
  const [exams, setExams] = useState([])

  useEffect(() => {
    axiosInstance.get(`${API}/getStudyYear`)
      .then((res) => {
        setYears(res.data)
        // ปีที่จำไว้ต้องมีอยู่จริงในรายการ — ไม่งั้นใช้ปีล่าสุด
        const saved = readYearId()
        if (res.data.length && !res.data.some((y) => String(y.year_id) === saved)) setYearId(String(res.data[0].year_id))
      })
      .catch(() => {})
  }, [])

  const load = useCallback(() => {
    if (!yearId) return
    setLoading(true)
    axiosInstance.get(`${API}/exams`, { params: { year_id: yearId } })
      .then((res) => setExams(res.data))
      .catch((err) => showError(err, 'โหลดรายการข้อสอบไม่สำเร็จ'))
      .finally(() => setLoading(false))
  }, [yearId, setLoading])

  useEffect(load, [load])

  const changeYear = (id) => {
    setYearId(id)
    try { localStorage.setItem('yearId', id) } catch { /* ไม่มี storage ก็ใช้ค่าในหน้าไป */ }
  }

  return (
    <>
      <Header onSkin={setSkin} />
      <div className="main main-app p-2 p-lg-4">
        <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
          <div className="me-auto">
            <h4 className="main-title mb-0">ข้อสอบและกระดาษคำตอบ</h4>
            <div className="fs-xs text-secondary">
              สร้างข้อสอบพร้อมเฉลย พิมพ์กระดาษคำตอบรายคน กรอกคำตอบ แล้วส่งคะแนนเข้าตารางคะแนน
            </div>
          </div>
          <Form.Select size="sm" style={{ width: 180 }} value={yearId || ''} onChange={(e) => changeYear(e.target.value)}>
            {years.map((y) => <option key={y.year_id} value={y.year_id}>ปีการศึกษา {y.year_year}</option>)}
          </Form.Select>
          <Button as={Link} to={`/teaching/exams/new${yearId ? `?year_id=${yearId}` : ''}`} size="sm">
            <i className="ri-add-line"></i> สร้างข้อสอบ
          </Button>
        </div>

        {exams.length === 0 ? (
          <Card className="card-one">
            <Card.Body className="text-center text-secondary py-5">
              <i className="ri-file-list-3-line fs-1 d-block mb-2"></i>
              ยังไม่มีข้อสอบในปีการศึกษานี้
            </Card.Body>
          </Card>
        ) : (
          <Row className="g-3">
            {exams.map((e) => (
              <Col key={e.exam_id} xs={12} md={6} xl={4}>
                <Card className="card-one h-100">
                  <Card.Body>
                    <Link to={`/teaching/exams/${e.exam_id}`} className="fw-semibold fs-6 d-block mb-1 text-decoration-none">
                      {e.exam_name}
                    </Link>
                    {e.rooms[0] && (
                      <div className="fs-sm text-secondary mb-2">
                        {e.rooms[0].sub_subid} {e.rooms[0].sub_subname} · ภาคเรียนที่ {e.rooms[0].sub_semester}
                      </div>
                    )}
                    <div className="d-flex flex-wrap gap-1 mb-2">
                      {e.rooms.map((r) => <Badge key={r.teach_id} bg="light" text="dark" className="border">{roomLabel(r)}</Badge>)}
                    </div>
                    <div className="fs-sm">
                      {e.question_count} ข้อ · เต็ม {fmt(e.total_points)} คะแนน · กรอกคำตอบแล้ว {e.response_count} คน
                    </div>
                  </Card.Body>
                  <Card.Footer className="bg-transparent d-flex gap-2">
                    <Button as={Link} to={`/teaching/exams/${e.exam_id}`} size="sm" variant="primary" className="flex-fill">
                      เปิด
                    </Button>
                    <Button as={Link} to={`/teaching/exams/${e.exam_id}/edit`} size="sm" variant="outline-secondary">
                      <i className="ri-edit-line"></i> แก้ไข
                    </Button>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
        )}
        <Footer />
      </div>
    </>
  )
}
